import React from 'react';
import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const starClasses = cva(
  'inline-block transition-all duration-200',
  {
    variants: {
      size: {
        small: 'w-4 h-4',
        medium: 'w-5 h-5',
        large: 'w-6 h-6',
        xlarge: 'w-8 h-8',
      },
      variant: {
        filled: 'text-yellow-400',
        empty: 'text-gray-300',
        half: 'text-yellow-400',
      },
    },
    defaultVariants: {
      size: 'medium',
      variant: 'filled',
    },
  }
);

const Star = ({
  size = 'medium',
  variant = 'filled',
  filled = true,
  className,
  onClick,
  ...props
}) => {
  const handleClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  const renderStar = () => {
    if (variant === 'half') {
      return (
        <svg
          viewBox="0 0 24 24"
          className={twMerge(starClasses({ size, variant }), className)}
          onClick={handleClick}
          {...props}
        >
          <defs>
            <linearGradient id="half-fill">
              <stop offset="50%" stopColor="currentColor" />
              <stop offset="50%" stopColor="#d1d5db" />
            </linearGradient>
          </defs>
          <path
            fill="url(#half-fill)"
            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
          />
        </svg>
      );
    }

    return (
      <svg
        viewBox="0 0 24 24"
        fill={filled || variant === 'filled' ? 'currentColor' : 'none'}
        stroke={!filled && variant === 'empty' ? 'currentColor' : 'none'}
        strokeWidth={2}
        className={twMerge(starClasses({ size, variant }), className)}
        onClick={handleClick}
        {...props}
      >
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    );
  };

  return renderStar();
};

export default Star;